import { render, staticRenderFns } from "./RommaLayer.vue?vue&type=template&id=30359fdb"
import script from "./RommaLayer.vue?vue&type=script&lang=js"
export * from "./RommaLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports